import { render, staticRenderFns } from "./PFormSelect.vue?vue&type=template&id=c0814b06&scoped=true&"
import script from "./PFormSelect.vue?vue&type=script&lang=ts&"
export * from "./PFormSelect.vue?vue&type=script&lang=ts&"
import style0 from "./PFormSelect.vue?vue&type=style&index=0&id=c0814b06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0814b06",
  null
  
)

export default component.exports